/** Making enemies and asking questions of the list. */

import { UP } from './math';
import { DIVE } from './tuning';
import type { Enemy, EnemyKind, GameState } from './types';

export function makeEnemy(s: GameState, kind: EnemyKind, x: number, y: number): Enemy {
  return {
    id: s.nextId++,
    kind,
    variant: 0,
    hp: kind === 'monarch' ? 2 : 1,
    slotted: false,
    row: 0,
    col: 0,
    wave: 0,
    state: 'entering',
    x,
    y,
    heading: UP,
    speed: 0,
    path: null,
    dist: 0,
    ox: 0,
    oy: 0,
    side: 0,
    after: 'leave',
    group: 0,
    escorts: 0,
    bombs: 0,
    bombTimer: 0,
    timer: 0,
    partner: -1,
    trio: 0,
    gone: false,
  };
}

export function findEnemy(s: GameState, id: number): Enemy | null {
  if (id < 0) return null;
  for (const e of s.enemies) if (e.id === id && !e.gone) return e;
  return null;
}

/** Away from the formation on an attack (not on its way in for the first time). */
export function isAloft(e: Enemy): boolean {
  if (e.gone) return false;
  return e.state === 'diving' || e.state === 'hover' || e.state === 'leaving' || (e.state === 'homing' && e.group !== 0);
}

export function anyAloft(s: GameState): boolean {
  return s.enemies.some(isAloft);
}

/** How many dive groups are out, counting a Stinger that is flashing into a trio as the group it is about to be. */
export function groupsInFlight(s: GameState): number {
  const ids: number[] = [];
  let morphing = 0;
  for (const e of s.enemies) {
    if (e.gone) continue;
    if (e.state === 'morphing') morphing++;
    else if (e.group !== 0 && isAloft(e) && !ids.includes(e.group)) ids.push(e.group);
  }
  return ids.length + morphing;
}

/** The last few never rest (02 §5). */
export function isFrenzy(s: GameState): boolean {
  return s.phase === 'battle' && s.enemies.length <= DIVE.frenzyAt;
}

/** For scoring and the rescue rule: anywhere but sitting in its slot. */
export function isDiving(e: Enemy): boolean {
  return e.state !== 'formed' && e.state !== 'morphing';
}
